export default "__VITE_ASSET__FCj3b$De__"